export default "__VITE_ASSET__tOQp6ait__"